<template id="dialog">
        <div class="dialog" v-if="showDialog">
            <div class="dialog_mask"></div>
           
            <div class="dialog_container">
                <div class='container'>
                    <!--<div class='close'  @click='closeDialog'></div>-->
                    <div class='list'>
                        <div class='title'>安  装  设  备  列  表<div class='close'  @click='closeDialog'></div></div>

                        <div class='table_style'
                             v-loading="is_loading"
                             element-loading-text="拼命加载中"
                             element-loading-spinner="el-icon-loading"
                             element-loading-background="rgba(0, 0, 0, 0.8)"
                            >
                            <table>
                                <tr>
                                    <th>序号</th>
                                    <th>安装地址</th>
                                    <th>安装日期</th>
                                    <th>联系人</th>
                                    <th>联系电话</th>
                                    <th>在线状态<i class="el-icon-sort sort_icon" @click="sort_online"></i></th>
                                    <th>阀门状态<i class="el-icon-sort sort_icon" @click="sort_valve"></i></th>
                                </tr>
                                <tr v-for='(item,index) in tableData'   :key='index'>
                                    <td>{{item.id}}</td>
                                    <td>{{item.realPos?item.realPos:'--'}}</td>
                                    <td>{{item.installDate?item.installDate:'--'}}</td>
                                    <td>{{item.user?item.user:'--'}}</td>
                                    <td>{{item.phone?item.phone:'--'}}</td>
                                    <td><i :class="{ offline: item.status=='0', online: item.status=='1' }"></i></td>
                                    <td>{{item.valve}}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
              
                 </div>
            </div>
        </div>
</template>
<script>
export default {
  props: {
        showDialog: {
            type: Boolean,
            default: false
        },
        is_loading: {
            type: Boolean,
            default: false
        },
        tableData:{
            type:Array,
            default:()=>[]
        },
        productType:{
            type:String,
            default:''
        }
      },
    data(){
        return{

            loading:true,
        }
    },
    components:{
      

    },
    mounted(){
        
    },
    
    methods:{
        closeDialog(){
            this.$emit('closeDialog');

        },
        close_alarm(){
            this.$emit('close_alarm')
        },
        sort_online(){
            this.$emit('sortOnline')
        },
        sort_valve(){
            this.$emit('sortValve')
        }
    }
}
</script>
<style lang="less" scoped>
.dialog{
    .dialog_mask{
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.9);
        z-index:10;
    }

    .container{
        width: 900px;
        height: 700px;
        position: fixed;
        top: 15%;
        left: 0px;
        right: 0px;
        margin-left:auto;
        margin-right:auto;
        z-index: 10;
       
        .close{
            width: 35px;
            height: 35px;
            cursor: pointer;
            margin-left: 95%;
            /*margin-bottom: 10px;*/
            // height: 20px;
            background: url(https://gas95.oss-cn-beijing.aliyuncs.com/monitor/static/img/close.png) no-repeat;
            background-size: 100% 100%;
            z-index: 10;
            position: absolute;
            bottom: 0px;
        
        }
        .list{
            width:886px;
            height: 650px;
            background: red;
            background: url(https://gas95.oss-cn-beijing.aliyuncs.com/monitor/static/img/dialog_bg.png) no-repeat;
            background-position: 50% 50%;
            background-size: 100% 100%;
            .title{
                height: 50px;
                text-align: center;
                font-size: 20px;
                color: #ffffff;
                line-height: 62px;
                position: relative;
            }
            .table_style{
                margin:20px 10px 20px 25px;
                height: 564px;
                // overflow: hidden;
                overflow-x: hidden;
                overflow-y: scroll;
                table{
                    width: 100%;
                    font-family: verdana,arial,sans-serif;
                    font-size:12px;
                    color:#333333;
                    border-width: 1px;
                    border-color: #666666;
                    border-collapse: collapse;
                    tr>th{
                        border-width: 1px;
                        padding: 8px;
                        background-color: #0b373f;
                        color: rgba(255,255,255,0.7);
                        font-size: 14px;
                        border:1px solid #000;
                        position: relative;
                        &::before{
                            content:"";
                            position:absolute;
                            top:0px;
                            left:0px;
                            height:0;
                            width:0;
                            border-top:8px solid #041520;
                            border-right:8px solid transparent;
                        }
                        .sort_icon{
                            margin-left: 5px;
                            cursor: pointer;
                        }

                    }
                    tr>td{
                        border-width: 1px;
                        padding: 8px;
                        border-style: solid;
                        border-color: #041520;
                        color: rgba(255,255,255,0.8);

                    }
                    .online{
                        text-align: center;
                        margin: 0 auto;
                        width: 10px;
                        height: 10px;
                        display: block;
                        background: green;
                        border-radius: 50%;
                    }
                    .offline{
                        text-align: center;
                        margin: 0 auto;
                        width: 10px;
                        height: 10px;
                        display: block;
                        background: gray;
                        border-radius: 50%;
                    }
                }
            }
        }
        
      
    }
    /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
  ::-webkit-scrollbar
  {
    width: 4px;
    height: 4px;
    background-color: transparent;
  }

  /*定义滚动条轨道 内阴影+圆角*/
  ::-webkit-scrollbar-track
  {
    //-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 6px;
    background-color: transparent;
  }

  /*定义滑块 内阴影+圆角*/
  ::-webkit-scrollbar-thumb
  {
    border-radius: 6px;
    //-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    background-color: rgba(4,122,135,0.6);
  }
   
}

</style>




// WEBPACK FOOTER //
// src/page/main_content/floor_distribution/device_list.vue